var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7103 19.9325L17.8088 16.0297C20.7281 12.1288 19.9321 6.60009 16.0309 3.68103C12.1296 0.761963 6.60048 1.5579 3.68117 5.45878C0.761866 9.35967 1.55787 14.8884 5.45908 17.8074C8.59286 20.1523 12.897 20.1523 16.0309 17.8074L19.934 21.7103C20.4245 22.2007 21.2198 22.2007 21.7102 21.7103C22.2008 21.2198 22.2008 20.4246 21.7102 19.9342L21.7103 19.9325ZM10.7775 17.0541C7.31028 17.0541 4.49958 14.2437 4.49958 10.7768C4.49958 7.30983 7.31028 4.49936 10.7775 4.49936C14.2447 4.49936 17.0554 7.30983 17.0554 10.7768C17.0517 14.2421 14.2432 17.0505 10.7775 17.0541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.0ecf186f59c164ea4eb8ec648bb7c6c3.svg";
export { ForwardRef as ReactComponent };